import Button from '@mui/material/Button';
import Input from '@mui/material/Input';
import AddIcon from '@mui/icons-material/Add';
import { useBulkProvisioningUpload } from './useBulkProvisioningUpload.ts';
import { useTranslation } from 'react-i18next';
import {
  uploadBulkProvisioningButtonDataTestId,
  uploadBulkProvisioningInputDataTestId,
} from '@/activityLog/bulkProvisioning/BulkProvisioningDataTestIds.ts';
import { UploadDialog } from './UploadDialog.tsx';
import Box from '@mui/material/Box';
import { pxToRem } from 'common/utils/fonts.ts';
import { UploadSnackbar } from '@/activityLog/common/Upload/UploadSnackbar.tsx';

export const BulkProvisioningUploadButton = () => {
  const { t } = useTranslation();

  const { selectedFile, selectFile, uploadFile, importError, setImportError, isPending } =
    useBulkProvisioningUpload();

  return (
    <Box>
      <label htmlFor="provisioning-jobs">
        <Input
          id="provisioning-jobs"
          name={uploadBulkProvisioningInputDataTestId}
          data-testid="upload bulk provisioning input"
          type="file"
          sx={{ display: 'none' }}
          onChange={(event) => {
            const fileInput = event.target as HTMLInputElement;
            if (fileInput?.files?.[0]) {
              selectFile(fileInput.files[0]);
              // file input cannot be controlled. This is hack to reset the input field that allow upload the same
              // file in row
              event.target.value = '';
            }
          }}
        />
        <Button
          data-testid={uploadBulkProvisioningButtonDataTestId}
          variant="contained"
          component="span"
          disabled={isPending}
          startIcon={<AddIcon sx={{ width: pxToRem(16), height: pxToRem(16) }} />}
          sx={{ py: 8, pl: 16, pr: 26, whiteSpace: 'nowrap' }}
        >
          {t('common.uploadFile')}
        </Button>
      </label>
      <UploadDialog
        open={!!selectedFile && !importError}
        fileName={selectedFile?.name || ''}
        onConfirm={() => {
          if (isPending || importError) {
            return;
          }
          uploadFile();
        }}
        onCancel={() => {
          selectFile(null);
        }}
      />
      <UploadSnackbar
        importError={importError}
        onClose={function (): void {
          setImportError(null);
          selectFile(null);
        }}
      />
    </Box>
  );
};
